import styled from "styled-components";

const PaginationWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    /* height: 74px; */
`;

const PaginationLabel = styled.p`
    font-family: "Source Sans Pro";
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    margin: 0;
    /* line-height: 21px; */

    &.pagination_label_legend {
        padding-right: 1rem;
    }
`;

// eslint-disable-next-line import/prefer-default-export
export { PaginationWrapper, PaginationLabel };
